"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_xor_1 = __importDefault(require("lodash.xor"));
var React = __importStar(require("react"));
var useFilters = function () {
    var _a = React.useState([]), filters = _a[0], setFilters = _a[1];
    var returnMatchingIndex = function (array, filter, key) {
        return array.findIndex(function (idv) { return idv[key] === filter[key]; });
    };
    var valueExists = function (values, valueToMatch) {
        var indexMatch;
        if (Array.isArray(values)) {
            indexMatch = values.findIndex(function (filterValue) {
                return filterValue === valueToMatch;
            });
            return indexMatch >= 0;
        }
        return values === valueToMatch;
    };
    var removeExistingFilter = function (existingFilters, filter) {
        var indexMatch = returnMatchingIndex(existingFilters, filter, 'key');
        var filterMatching = existingFilters[indexMatch];
        var removeValue = Array.of(filter.value.toString());
        var existingValues = Array.isArray(filterMatching.value) ? filterMatching.value : Array.of(filterMatching.value);
        existingValues.map(function (val) { return val.toString(); });
        var newValues = lodash_xor_1.default(existingValues, removeValue);
        if (newValues.length === 0) {
            return [];
        }
        var newFilters = __spreadArray([], existingFilters);
        newFilters[indexMatch] = __assign({
            key: filterMatching.key,
            value: newValues,
        });
        return newFilters;
    };
    var addToExistingFilters = function (existingFilters, filter) {
        var indexMatch = existingFilters.findIndex(function (efilter) { return efilter.key === filter.key; });
        if (indexMatch < 0) {
            return __spreadArray(__spreadArray([], existingFilters), [filter]);
        }
        var matchingFilterValues = existingFilters[indexMatch].value;
        var newFiltersValues = Array.isArray(matchingFilterValues)
            ? __spreadArray(__spreadArray([], matchingFilterValues), [filter.value.toString()]) : Array.of(matchingFilterValues, filter.value).flat();
        var newFilters = __spreadArray([], existingFilters);
        newFilters[indexMatch] = __assign({}, existingFilters[indexMatch]);
        newFilters[indexMatch].value = newFiltersValues;
        return __spreadArray([], newFilters);
    };
    var addFilter = function (filterToAdd) {
        var filterIndex = filters.findIndex(function (item) { return item.key === filterToAdd.key && valueExists(item.value, filterToAdd.value); });
        var filterExists = filterIndex >= 0;
        // This will set the table back to page 1 on a new filter
        // TODO?
        // this.setState({ page: 1 });
        var updatedFilters = filterExists
            ? removeExistingFilter(filters, {
                key: filterToAdd.key,
                value: Array.of(filterToAdd.value.toString()),
            })
            : addToExistingFilters(filters, {
                key: filterToAdd.key,
                value: Array.of(filterToAdd.value.toString()),
            });
        setFilters(updatedFilters);
    };
    var clearFilters = function () {
        setFilters([]);
    };
    var removeFilter = function (key) {
        var updatedFilters = filters.filter(function (item) { return item.key !== key; });
        setFilters(updatedFilters);
    };
    return [filters, addFilter, removeFilter, clearFilters];
};
exports.default = useFilters;
